module.exports = __webpack_public_path__ + "static/img/Order.fw.25a9292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Order.fw.png
// module id = Kz4p
// module chunks = 1